module.exports = __webpack_public_path__ + "static/media/so.c6b99170.svg";